import './Solution.css';

export default function Solution() {
  return (
    <section id="solution" className="solution section">
      <div className="container">
        <h2>
          We Turn Your Camera Roll
          <br />
          Into Cinema
        </h2>
        <p className="solution-text">
          Think of your favourite film. It's not a random collection of scenes - it's a story,
          carefully crafted, building from one moment to the next.
          <br />
          <br />
          Your family has a story too. And we know how to tell it.
          <br />
          <br />
          You choose the moments that matter. We weave them into something extraordinary. A
          professionally edited video that captures not just what happened, but how it felt to live
          through it.
          <br />
          <br />
          The result? A visual time capsule. A keepsake that gets watched, not stored.
        </p>

        <div className="solution-extra">
          <h3 className="solution-extra-title">Need something other than Kids Vids?</h3>
          <p className="solution-extra-text">
            Kids Vids is our signature service, but our team also does general video editing. If
            you've got footage that matters and you want it to feel polished, emotional, and easy
            to share, we can help.
          </p>
          <ul className="solution-extra-list">
            <li>Wedding films and highlights (even if they were shot by friends or family)</li>
            <li>Memorial / celebration of life tribute videos</li>
            <li>Birthday, anniversary, and milestone montages</li>
            <li>Holiday and travel films</li>
            <li>Family history "this is your life" style edits</li>
          </ul>
          <p className="solution-extra-note">
            Tell us what it's for, share what you've got, and we'll shape it into a story.
          </p>
        </div>

        <h3 className="solution-process-title">How it works</h3>
        <p className="solution-process-subtitle">From Scattered Files to Stunning Film</p>
        <br />
        <br />
        <div className="solution-process">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="process-step-content">
              <h3>You Curate</h3>
              <p>
                Go through your photos and videos. Pick the moments that make you smile, laugh, or
                tear up a little. First bath, first words, first day of school, Sunday morning
                pancakes - whatever tells your story.
              </p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="process-step-content">
              <h3>You Upload</h3>
              <p>
                Send your files to us via secure cloud upload. No technical headaches, no
                complicated software. Just point, click, and let us take it from there.
              </p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="process-step-content">
              <h3>We Create</h3>
              <p>
                This is where the magic happens. Using our professional television production
                experience, we craft your clips into a narrative that flows. We handle pacing,
                transitions, music, and all the technical wizardry that turns raw footage into
                something cinematic.
              </p>
            </div>
          </div>
          <div className="process-step">
            <div className="step-number">4</div>
            <div className="process-step-content">
              <h3>You Treasure</h3>
              <p>
                Receive your finished film, ready to watch whenever the mood strikes. Share it with
                family overseas. Play it at milestone celebrations. Watch your children see
                themselves grow up before their eyes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
